import { Button, Form, Input, message, Modal } from 'antd'
import { useImperativeHandle, useState, forwardRef, useRef } from 'react'
import { SYSCON } from '@/const/const'
import styles from './wechat-bind.scss'
import User from '@/modules/user'
const WechatBind = (props, ref) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [wechatInfo, setWechatInfo] = useState(null)
  const formRef = useRef()
  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(
    ref,
    () => ({
      open
    }),
    []
  )
  const open = (info) => {
    setWechatInfo({ ...info })
    setModalVisible(true)
  }
  const handleBind = () => {
    const fromData = formRef.current.getFieldsValue(true)
    const password = window.btoa(fromData.password)
    const bindData = {
      phone: fromData.phone,
      password: password,
      openid: wechatInfo.openId,
      unionid: wechatInfo.unionId,
      microAppCd: wechatInfo.microAppCd || SYSCON.PlatMicroAppFinMp
    }
    console.log({ bindData })
    const user = new User()
    user.bindUserWechat(bindData)
      .then(res => {
        props.binded(res)
        message.success('绑定成功')
        setModalVisible(false)
      })
      .catch(err => {
        console.log(err)
        setModalVisible(false)
      })
  }
  return (
    <Modal
      destroyOnClose
      title='微信绑定'
      visible={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
      width={400}
    >
      <Form
        ref={formRef}
        onFinish={handleBind}
        name='wechat_bind'
      >
        <Form.Item
          name='phone'
          rules={[{ required: true, message: '手机号不能为空' }]}
          getValueFromEvent={(e) => e.target.value.trim()}
        >
          <Input placeholder='手机号/用户名' />
        </Form.Item>
        <Form.Item
          name='password'
          rules={[{ required: true, message: '密码不能为空' }]}
        >
          <Input.Password
            className={styles['select-ban']}
            onCopy={(e) => e.preventDefault()}
            placeholder='请输入密码'
          />
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' className={styles['bind-form-button']}>
              绑定
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default forwardRef(WechatBind)
